/* prettier-ignore-start */
/* eslint-disable */
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols
// This file is auto-generated by TanStack Router

import { createFileRoute, createRootRouteWithContext } from '@tanstack/react-router'

// Import Routes
import { Route as rootRoute } from './routes/__root'
import { Route as IndexImport } from './routes/index'
import { Route as RegisterImport } from './routes/register'
import { Route as ResetPasswordImport } from './routes/reset-password'
import { Route as ResetPasswordConfirmImport } from './routes/reset-password.confirm'
import { Route as EmployeeImport } from './routes/employee'
import { Route as SupervisorImport } from './routes/supervisor'
import { Route as ExecutiveImport } from './routes/executive'
import { Route as QualityImport } from './routes/quality'
import { Route as AdminImport } from './routes/admin'
import { Route as DutyManagerImport } from './routes/duty-manager'

// Create/update Routes

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const RegisterRoute = RegisterImport.update({
  path: '/register',
  getParentRoute: () => rootRoute,
} as any)

const ResetPasswordRoute = ResetPasswordImport.update({
  path: '/reset-password',
  getParentRoute: () => rootRoute,
} as any)

const ResetPasswordConfirmRoute = ResetPasswordConfirmImport.update({
  path: '/reset-password/confirm',
  getParentRoute: () => rootRoute,
} as any)

const EmployeeRoute = EmployeeImport.update({
  path: '/employee',
  getParentRoute: () => rootRoute,
} as any)

const SupervisorRoute = SupervisorImport.update({
  path: '/supervisor',
  getParentRoute: () => rootRoute,
} as any)

const ExecutiveRoute = ExecutiveImport.update({
  path: '/executive',
  getParentRoute: () => rootRoute,
} as any)

const QualityRoute = QualityImport.update({
  path: '/quality',
  getParentRoute: () => rootRoute,
} as any)

const AdminRoute = AdminImport.update({
  path: '/admin',
  getParentRoute: () => rootRoute,
} as any)

const DutyManagerRoute = DutyManagerImport.update({
  path: '/duty-manager',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id:          '/';
      path:        '/';
      fullPath:    '/';
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    '/register': {
      id:          '/register';
      path:        '/register';
      fullPath:    '/register';
      preLoaderRoute: typeof RegisterImport;
      parentRoute: typeof rootRoute;
    };
    '/reset-password': {
      id:          '/reset-password';
      path:        '/reset-password';
      fullPath:    '/reset-password';
      preLoaderRoute: typeof ResetPasswordImport;
      parentRoute: typeof rootRoute;
    };
    '/reset-password/confirm': {
      id:          '/reset-password/confirm';
      path:        '/reset-password/confirm';
      fullPath:    '/reset-password/confirm';
      preLoaderRoute: typeof ResetPasswordConfirmImport;
      parentRoute: typeof rootRoute;
    };
    '/employee': {
      id:          '/employee';
      path:        '/employee';
      fullPath:    '/employee';
      preLoaderRoute: typeof EmployeeImport;
      parentRoute: typeof rootRoute;
    };
    '/supervisor': {
      id:          '/supervisor';
      path:        '/supervisor';
      fullPath:    '/supervisor';
      preLoaderRoute: typeof SupervisorImport;
      parentRoute: typeof rootRoute;
    };
    '/executive': {
      id:          '/executive';
      path:        '/executive';
      fullPath:    '/executive';
      preLoaderRoute: typeof ExecutiveImport;
      parentRoute: typeof rootRoute;
    };
    '/quality': {
      id:          '/quality';
      path:        '/quality';
      fullPath:    '/quality';
      preLoaderRoute: typeof QualityImport;
      parentRoute: typeof rootRoute;
    };
    '/admin': {
      id:          '/admin';
      path:        '/admin';
      fullPath:    '/admin';
      preLoaderRoute: typeof AdminImport;
      parentRoute: typeof rootRoute;
    };
    '/duty-manager': {
      id:          '/duty-manager';
      path:        '/duty-manager';
      fullPath:    '/duty-manager';
      preLoaderRoute: typeof DutyManagerImport;
      parentRoute: typeof rootRoute;
    };
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  RegisterRoute,
  ResetPasswordRoute,
  ResetPasswordConfirmRoute,
  EmployeeRoute,
  SupervisorRoute,
  DutyManagerRoute,
  ExecutiveRoute,
  QualityRoute,
  AdminRoute,
})

/* prettier-ignore-end */
